export const formatName = (name) => {
  if (!name) return name;
  return name
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatMobile = (mobile) => {
  if (!mobile) return mobile;
  const cleaned = mobile.toString().replace(/\s+/g, ''); // Remove spaces
  if (cleaned.startsWith('+91')) {
    return cleaned;
  }
  return `+91${cleaned}`;
};

export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '';
  const num = Number(amount);
  if (isNaN(num)) return amount;
  
  // Check if it has decimal part
  if (num % 1 !== 0) {
    return `₹ ${num.toFixed(2)}`;
  }
  return `₹ ${num}`;
};

